<script>
  import { layoutMethods, kantoAdsMethods, kantoAdsComputed, exportMethods, erpFixMessages } from "@/state/helpers";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import Swal from "sweetalert2";

  /**
   * Cancellation Form List component
   */
  export default {
    page: {
      title: "Cancellation Form"
    },
    components: {
      flatPickr
    },
    computed: {
      ...kantoAdsComputed,
      ...erpFixMessages,
      viewImgUrl(){
        var img = require('@/assets/images/img-placeholder.png');
        try {
          if(this.cancellationRequestDetails.s3SingedURLAuditImg ==null){
            img = this.cancellationRequestDetails.s3SingedURLAuditImg
          }
        } catch (error) {
            console.log(">> viewImgUrl:",error);
        }
        return img;
      }
    },
    data() {
      return {
        cancellationId:0,
        title: "Cancellation Form",
        cancellationRequestForm:{status:null,description:null,max:100,cancellationId:0},
        formExitChecker:{status:null,description:null,max:100,cancellationId:0},
        cancellationOptions: [
          { text: "Select Peddlr Assessment", value: null, disabled:true },
          { text: "Accepted", value: "accepted" },
          { text: "Denied", value: "denied" },
        ],
        isLoaded:false,
        visibleSpaceImg: false,
        imgIndex: 0,
        auditSpaceSignUrls:[],
        isEditabled:true,
        fields: [
          {key: "modifiedBy",sortable: false},
          {key: "modifiedAt", label: "Modified Date & Time", sortable: false},
          {key: "checkpointMonth",sortable: false},
          {key: "status",sortable: false},
          {key: "refundAmount",sortable: false},
          {key: "remarks",sortable: false},
        ],
        searchValue: {
            page: 1,
            rows: 10,
            dateRange:null
        },
        rangeOption: {
          mode: "range",
        },
      };
    },
    methods: {
      ...layoutMethods,
      ...kantoAdsMethods,
      ...exportMethods,
      submitForm(){
        if(!this.isEditabled){
          return Swal.fire("Failed!", "Unabled to update!", "warning"); 
        }
        Swal.fire({
            title: 'Are you sure would like to confirm this  assessment?',
            text: `Peddlr assessment will not be editable once APPROVED and REJECTED. Remarks not editable after approved and rejected`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#E83092',
            cancelButtonColor: '#7F4697',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
              this.formAuditCancallationRequest(this.cancellationRequestForm).then(()=>{ 
                console.log("><><><><><> form:",JSON.stringify(this.cancellationRequestForm));
                Swal.fire("Update Successful!!", `${this.cancellationRequestDetails.brandOwner} has been updated.`, "success"); 
                this.formExitChecker = this.cancellationRequestForm;
                this.goBack();
              });
            }else{
                return;
            }
        })
      },
      getValidationState({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null;
      },
      getDetails(){
        this.fetchAuditCancallationRequest(this.cancellationId).then(()=>{
          if(Object.prototype.hasOwnProperty.call(this.cancellationRequestDetails, "id")){
            this.cancellationRequestForm.cancellationId = this.cancellationRequestDetails.id;
            this.formExitChecker.cancellationId = this.cancellationRequestDetails.id;
            this.isLoaded =true;
            console.log(">>> cancellationRequestDetails",JSON.stringify(this.cancellationRequestDetails));
            this.auditSpaceSignUrls = [];
            if(this.cancellationRequestDetails.s3SingedURLAuditImg != null){
              for(let x of this.cancellationRequestDetails.s3SingedURLAuditImg){ 
                this.auditSpaceSignUrls.push(x.url);
              }
            }
            console.log(">>>>>fetchAuditCancallationRequest?");
            if(this.cancellationRequestDetails.cancelStatus != 'pending'){
              console.log(">>>>>not editable");
              this.isEditabled = false
              //cancellationRequestForm:{status:null,description:null,max:100,cancellationId:0},
              this.cancellationRequestForm.status = ['accepted','approved'].includes(this.cancellationRequestDetails.cancelStatus) ? 'accepted' : this.cancellationRequestDetails.cancelStatus
              this.cancellationRequestForm.description = this.cancellationRequestDetails.cancelremarks
              this.formExitChecker = this.cancellationRequestForm;
            }
          }else{
            Swal.fire("Failed!", "Cancellation Request is not found!", "warning"); 
            this.goBack();
          }
        });
      },
      goBack(){
        this.$router.push(
          this.$route.query.redirectFrom || {
            name: "Audit Cancellation"
          }
        );
      },
      openModal(modal=''){
        this.search('reset');
        this.$bvModal.show(modal);
      },
      closeModal(modal=''){
        this.$bvModal.hide(modal);
      },
      async search(status) {
        if(status == "reset"){
          this.searchValue.page = 1;
        }
        await this.auditCancellationRequestLogs({...this.searchValue, "cancellationId":this.cancellationId})
        .then(()=>{
        });
      },
      async onExport(){
          await this.search();
          if(this.cancellationLogsTotal == 0)
          {
            Swal.fire("Failed!", this.exportNullPrompt, "warning");
            return;
          }
          let params = {...this.searchValue, "cancellationId":this.cancellationId, email: JSON.parse(localStorage.getItem("userData")).email, module: 'kantoads_audit_cancellation_logs'};
          console.log("params: ", params);
          
          this.exportReport(params)
            .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
            .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
      },
      leaveform(next){
          if(JSON.stringify(this.cancellationRequestForm) == JSON.stringify(this.formExitChecker)){
            next();
            return;
          }
          Swal.fire({
              title: 'Are you sure?',
              text: "you want to leave this page?",
              icon: 'question',
              showCancelButton: true,
              confirmButtonColor: '##804997',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No'
          }).then((result) => {
              if (result.isConfirmed) {
                  next();
              }else{
                  return;
              }
          })
      },
    },
    async mounted(){
      this.cancellationId = this.$route.params.id;
      this.changeTitle({title: 'Update Cancellation'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'} },
          { text: 'Kanto Ads', to: { name: 'Kanto Ads'} },
          { text: 'Cancellation', to: { name: 'Audit Cancellation'} },
          { text: 'Cancellation Form', to: { name: 'Audit Cancellation Form'} }
        ]
      });
      this.getDetails();
    },
    beforeRouteLeave(to, from, next) {
        if(JSON.stringify(this.cancellationRequestForm) != JSON.stringify(this.formExitChecker)){
          this.leaveform(next);
        }else{
          next();
        }
    }
  }
    
</script>

<template>
  <div><!-- outer div-->
      <vue-easy-lightbox
        escDisabled
        moveDisabled
        :visible="visibleSpaceImg"
        :index="imgIndex"
        :imgs="auditSpaceSignUrls"
        @hide="visibleSpaceImg = false"
      ></vue-easy-lightbox>
      <div class="row">
          <div class="col-md-7 col-12">
            <div class="card">
                <div class="card-body">
                  <div class="d-flex mb-3 border-bottom pb-2 text-dark">
                    <div class="flex-grow-1 my-auto">
                      <span class="align-middle fw-semibold" @click="getDetails">Full Details</span>
                    </div>
                  </div>
                  <div class="row" v-if="isLoaded">
                    <div class="col-lg-12">
                      <div class="row m-b-9">
                        <div class="col-4">
                          <p class="font-size-13 fw-semibold">Cancellation Request Number:</p>
                        </div>
                        <div class="col-8 text-capitalize">
                          <p class="font-size-13 text-end">{{cancellationRequestDetails.refNo}}</p>
                        </div>
                      </div>
                      <div class="row m-b-9">
                        <div class="col-4">
                          <p class="font-size-13 fw-semibold">Brand Owner:</p>
                        </div>
                        <div class="col-8 text-capitalize">
                          <p class="font-size-13 text-end">{{cancellationRequestDetails.brandOwner}}</p>
                        </div>
                      </div>
                      <div class="row m-b-9">
                        <div class="col-4">
                          <p class="font-size-13 fw-semibold">SSS Listing:</p>
                        </div>
                        <div class="col-8 text-capitalize">
                          <p class="font-size-13 text-end">{{cancellationRequestDetails.sssStore}}</p>
                        </div>
                      </div>
                      <div class="row m-b-9">
                        <div class="col-4">
                          <p class="font-size-13 fw-semibold">Collateral Type:</p>
                        </div>
                        <div class="col-8 text-capitalize">
                          <p class="font-size-13 text-end">{{cancellationRequestDetails.collateralType}}</p>
                        </div>
                      </div>
                      <div class="row m-b-9">
                        <div class="col-4">
                          <p class="font-size-13 fw-semibold">SSS Collateral Status:</p>
                        </div>
                        <div class="col-8 text-capitalize">
                          <p class="font-size-13 text-end">{{cancellationRequestDetails.collateralStatus}}</p>
                        </div>
                      </div>
                      <div class="row m-b-9">
                        <div class="col-4">
                          <p class="font-size-13 fw-semibold">Contract Duration (Months):</p>
                        </div>
                        <div class="col-8 text-capitalize">
                          <p class="font-size-13 text-end">{{cancellationRequestDetails.contractDuration}}</p>
                        </div>
                      </div>
                      <div class="row m-b-9">
                        <div class="col-4">
                          <p class="font-size-13 fw-semibold">Contract Amount:</p>
                        </div>
                        <div class="col-8 text-capitalize">
                          <p class="font-size-13 text-end">PHP {{cancellationRequestDetails.contractAmount | toCurrency}}</p>
                        </div>
                      </div>
                      <div class="row m-b-9">
                        <div class="col-4">
                          <p class="font-size-13 fw-semibold">Released Duration (Months): </p>
                        </div>
                        <div class="col-8 text-capitalize">
                          <p class="font-size-13 text-end">{{cancellationRequestDetails.releasedDuration}}</p> 
                        </div>
                      </div>
                      <div class="row m-b-9">
                        <div class="col-4">
                          <p class="font-size-13 fw-semibold">Released Amount to SSS:</p>
                        </div>
                        <div class="col-8">
                          <p class="font-size-13 text-end">PHP {{cancellationRequestDetails.sssReleasedAmount | toCurrency}}</p>
                        </div>
                      </div>
                      <div class="row m-b-9">
                        <div class="col-4">
                          <p class="font-size-13 fw-semibold">Peddlr Profit:</p>
                        </div>
                        <div class="col-8">
                          <p class="font-size-13 text-end">PHP {{cancellationRequestDetails.peddlrProfit | toCurrency}}</p>
                        </div>
                      </div>
                      <div class="row m-b-9">
                        <div class="col-4">
                          <p class="font-size-13 fw-semibold">Cancellation Fee:</p>
                        </div>
                        <div class="col-8">
                          <p class="font-size-13 text-end">PHP {{cancellationRequestDetails.cancellationFee | toCurrency}}</p>
                        </div>
                      </div>
                      <div class="row m-b-9">
                        <div class="col-4">
                          <p class="font-size-13 fw-semibold">Rented Date and Time:</p>
                        </div>
                        <div class="col-8">
                          <p class="font-size-13 text-end">{{cancellationRequestDetails.rentedDate | formatDateNoComma}}</p>
                        </div>
                      </div>
                      <div class="row m-b-9">
                        <div class="col-4">
                          <p class="font-size-13 fw-semibold">Type of Cancellation:</p>
                        </div>
                        <div class="col-8">
                          <p class="font-size-13 text-end">{{cancellationRequestDetails.cancellationType}}</p>
                        </div>
                      </div>
                      <div class="row m-b-9">
                        <div class="col-4">
                          <p class="font-size-13 fw-semibold">Cancellation Date Requested:</p>
                        </div>
                        <div class="col-8">
                          <p class="font-size-13 text-end">{{cancellationRequestDetails.requestDate | formatDateNoComma}}</p>
                        </div>
                      </div>
                      <div class="row m-b-9">
                        <div class="col-4">
                          <p class="font-size-13 fw-semibold">Attempt:</p>
                        </div>
                        <div class="col-8">
                          <p class="font-size-13 text-end text-capitalize">{{cancellationRequestDetails.attempt}}</p>
                        </div>
                      </div>
                      <div class="row m-b-9">
                        <div class="col-4">
                          <p class="font-size-13 fw-semibold">Status:</p>
                        </div>
                        <div class="col-8 text-capitalize">
                          <p class="font-size-13 text-end" 
                          :class="{
                            'text-warning':cancellationRequestDetails.cancelStatus == 'pending',
                            'text-danger':cancellationRequestDetails.cancelStatus == 'denied',
                            'text-success':['accepted','approved'].includes(cancellationRequestDetails.cancelStatus)
                            }">
                            {{cancellationRequestDetails.cancelStatus}}
                          </p>
                        </div>
                      </div>
                      <div class="row m-b-9">
                        <div class="col-4">
                          <p class="font-size-13 fw-semibold">Uploaded Photo:</p>
                        </div>
                        <div class="col-8">
                          <div class="img-container text-end">
                            <img :src="cancellationRequestDetails.s3SingedURLAuditImg != null && cancellationRequestDetails.s3SingedURLAuditImg.length > 0 ? cancellationRequestDetails.s3SingedURLAuditImg[0].url : require('@/assets/images/img-placeholder.png')" @error="(e) => e.target.src = require('@/assets/images/img-placeholder.png')" style="width:35%;">
                            <div class="img-txt-centered fw-semibold c-pointer" @click="visibleSpaceImg = true;">View Image</div>
                          </div>
                        </div>
                      </div>
                      <div class="row m-b-9">
                        <div class="col-12">
                          <p class="font-size-13 fw-semibold">Remarks:</p>
                          <p class="font-size-13">{{cancellationRequestDetails.remarks}}</p>
                        </div>
                      </div>
                      <hr>
                      <ValidationObserver v-slot="{ handleSubmit, reset }">
                        <b-form
                          ref="collateralSetupForm"
                          @submit.prevent="handleSubmit(submitForm)"
                          @reset.prevent="reset"
                        >
                          <b-form-group class="mt-4 ts-14">
                            <label>Peddlr Assessment<span style="color: red">*</span></label>
                            <validation-provider
                              name="select assessment"
                              rules="required"
                              v-slot="validationContext"
                            >
                              <b-form-select
                                v-model="cancellationRequestForm.status"
                                :options="cancellationOptions"
                                class="form-select mb-3 shadow-none"
                                :state="getValidationState(validationContext)"
                                :disabled="!isEditabled"
                              >
                              </b-form-select>
                              <b-form-invalid-feedback>
                                {{ validationContext.errors[0] }}
                              </b-form-invalid-feedback>
                            </validation-provider>
                          </b-form-group>
                          <b-form-group class="mt-4 ts-14">
                            <label>
                              Remarks Assessment <span class="text-danger">*</span> 
                            </label>
                            <validation-provider
                              name="description"
                              rules="required"
                              v-slot="validationContext"
                            >
                              <b-form-textarea
                                id="textarea"
                                v-model="cancellationRequestForm.description"
                                placeholder="Type remarks..."
                                :state="getValidationState(validationContext)"
                                rows="3"
                                max-rows="6"
                                maxlength="100"
                                :disabled="!isEditabled"
                              ></b-form-textarea>
                            <small class="text-muted">{{cancellationRequestForm.description == null ? 0 : cancellationRequestForm.description.length}} / {{ cancellationRequestForm.max}}</small>
                              <b-form-invalid-feedback>
                                {{ validationContext.errors[0] }}
                              </b-form-invalid-feedback>
                            </validation-provider>
                          </b-form-group>
                          <div class="mt-2">
                            <span>
                              <b class="me-2">Change Log:</b>
                              <b-link @click="openModal('bv-modal-view-logs')">View</b-link>
                            </span>
                            <router-link :to="{ name: 'Audit Cancellation'}" class="text-capitalize">
                              <b-button
                                class="float-end me-2"
                                type="button"
                                variant="secondary"
                              >
                                close
                              </b-button>
                            </router-link>
                            <b-button
                              class="float-end me-2"
                              type="submit"
                              variant="primary" v-if="isEditabled"
                            >
                              Update
                            </b-button>
                          </div>
                        </b-form>
                      </ValidationObserver>
                    </div><!--end-->
                  </div>
                  <div class="row g-0 text-center" v-else>
                    <span>No data to display.</span>
                  </div>
                  <b-modal id="bv-modal-view-logs" title="View Logs" size="lg" hide-header hide-title hide-footer hide-header-close>
                    <!-- <span class="float-end c-pointer " @click="closeModal('bv-modal-view-logs')"><i class="bx bx-x"></i></span> -->
                    <h5>Cancellation Log</h5>
                    <div class="d-flex flex-row col-12 my-4">
                      <div class="me-3">
                        <b-form-group>
                          <template v-slot:description><div class="d-flex justify-content-end">Filter by Date</div></template>
                          <flat-pickr
                            v-model="searchValue.dateRange"
                            :config="rangeOption"
                            placeholder="Select a date range"
                            class="form-control"
                            style="width: fit-content"
                          ></flat-pickr>
                        </b-form-group>
                      </div>
                      <div class="me-3">
                        <b-form-group label="">
                          <b-button variant="primary" type="button" class="px-2 me-3" @click="search('reset')">
                            <i class='bx bx-search bx-fw'></i>
                            Search
                          </b-button>
                          <b-button variant="primary" type="button" class="px-2" @click="onExport">
                            <i class="uil uil-export me-1"></i>
                            Export
                          </b-button>
                        </b-form-group>
                      </div>
                    </div>
                    <div>
                      <div class="table-responsive">
                        <div class="table align-middle table-nowrap">
                          <b-table
                            :items="cancellationLogs"
                            :fields="fields"
                            responsive="md"
                            class="table-check"
                          >
                            <template #cell(refundAmount)="data">
                              <p class="text-capitalize text-end">PHP {{ data.item.refundAmount | toCurrency}}</p>
                            </template>
                            <template #cell(modifiedAt)="data">
                              {{ data.item.modifiedAt | formatDateNoComma}}
                            </template>
                            <template #cell(status)="data">
                              <p class="text-capitalize">{{ data.item.status}}</p>
                            </template>
                          </b-table>
                        </div>
                      </div>
                      <div class="row g-0 text-center" v-if="cancellationLogsTotal == 0">
                        <span>No data to display.</span>
                      </div>
                      <div class="row" v-if="cancellationLogsTotal != 0 && cancellationLogsTotal > searchValue.rows">
                        <div class="col">
                          <div
                            class="
                              dataTables_paginate
                              paging_simple_numbers
                              float-end
                            "
                          >
                            <!-- pagination -->
                            <b-pagination
                              class="pagination-rounded"
                              v-model="searchValue.page"
                              :total-rows="cancellationLogsTotal"
                              @input="search()"
                              :per-page="searchValue.rows"
                            ></b-pagination>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="text-end">
                      <b-button type="button" variant="light" @click="closeModal('bv-modal-view-logs')">
                        close
                      </b-button>
                    </div>
                  </b-modal>
                </div>
                <!-- end card body -->
            </div>
            <!-- end card -->
          </div><!-- end col-lg-12 -->
      </div><!-- end of row-->
  </div> <!-- end of outer div-->
</template>
<style>
.img-container {
  position: relative;
  text-align: center;
  color: white;
}
.img-txt-centered {
  position: absolute;
  top: 50%;
  left: 50%;
  width:100%;
  height:100%;
  background: rgba(255,255,255, .5);
  color:#E83092;
  transform: translate(-50%, -50%);
  padding:8%;
  text-decoration: underline;  
}
</style>